import { BUSCAR_ROTAS_ITINERARIO, ALTERAR_DETALHAMENTO_ROTA_ITINERARIO } from '../../actions/types'

const initialState = {
  rota: []
}

export default function reducerRotasItinerarios(state = initialState, action) {
  switch (action.type) {
    case BUSCAR_ROTAS_ITINERARIO: {
      if (action.payload.data) {
        const rota = action.payload.data.rotas.map(rota => Object.assign({}, rota, { exibirDetalhe: false, trechoFoiPesquisado: false }));
        const total = action.payload.data.total;

        return {
          ...state,
          rota,
          total: total
        }
      }
      return state
    }

    case ALTERAR_DETALHAMENTO_ROTA_ITINERARIO: {
      const rotas = action.payload.rota;
      const itinerarios = action.payload.itinerarios;
      const trechos = action.payload.trechos;

      const indice = state.rota.findIndex((i) => i.id === rotas.id)
      let novaRota = null;

      if(itinerarios && trechos) {
        novaRota = Object.assign({}, rotas, { exibirDetalhe: true, trechoFoiPesquisado: true, trechos: trechos, itinerarios: itinerarios });
      } else {
        novaRota = Object.assign({}, rotas, { exibirDetalhe: !rotas.exibirDetalhe, trechoFoiPesquisado: false, trechos: trechos, itinerarios: itinerarios });
      }

      const rota = Object.assign([], state.rota);
      rota[indice] = novaRota;

      return {
        ...state,
        rota
      }
    }

    default: {
      return state
    }
  }
}
